import React, { useEffect, useState } from 'react';

import { CSSBlockPage } from '@core/constants';
import { getClients } from '@core/services/networkService/_client';
import { nscRequest } from '@helpers/app.helper';
import { Client } from '@models/client.model';

import ClientsTable from './ClientsTable';

const ClientsPage: React.FC = () => {
  const CSSBlock = 'clients';
  const [clients, setClients] = useState<Client[]>([]);

  useEffect(() => {
    nscRequest(getClients()).then(o => setClients(o));
  }, []);

  return (
    <div className={`${CSSBlockPage} ${CSSBlock}`}>
      <div className={`${CSSBlockPage}__title`}>Clients List</div>
      <ClientsTable clients={clients} />
    </div>
  );
};

export default ClientsPage;
